/*
    Copyright NetFoundry Inc.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

export const URLS = {
    ZITI_DASHBOARD: '/dashboard',
    ZITI_ATTRIBUTES: '/attributes',
    ZITI_IDENTITIES: '/identities',
    ZITI_JWT_SIGNERS: '/jwt-signers',
    ZITI_SERVICES: '/services',
    ZITI_ROUTERS: '/routers',
    ZITI_TRANSIT_ROUTERS: '/transit-routers',
    ZITI_CONFIGS: '/configs',
    ZITI_CONFIG_TYPES: '/config-types',
    ZITI_RECIPES: '/recipes',
    ZITI_TERMINATORS: '/terminators',
    ZITI_AUTH_POLICIES: '/auth-policies',
    ZITI_SERVICE_POLICIES: '/service-policies',
    ZITI_ROUTER_POLICIES: '/router-policies',
    ZITI_SERVICE_ROUTER_POLICIES: '/service-router-policies',
    ZITI_POSTURE_CHECKS: '/posture-checks',
    ZITI_CERT_AUTHORITIES: '/certificate-authorities',
    ZITI_SESSIONS: '/sessions',
    ZITI_API_SESSIONS: '/api-sessions',
    ZITI_LOGIN: '/login',
    ZITI_ORGANIZATION: '/organization',
    ZITI_PROFILE: '/profile',
    ZITI_SERVERS: '/servers',
    ZITI_SETTINGS: '/settings',
    ZITI_CUSTOM_FIELDS: '/custom-fields',
    ZAC_LOGIN: '/login',
    NETWORK_VISUALIZER: '/network-visualizer'
};
